export const environment = {
    production: true,
    tenant: "mondis",
    loginToken: "c153681b-7514-4871-a13f-a24611463ac0",
    apiServerUrl: `/api-server`,
    // wedo firebase account
    firebase: {
        apiKey: "AIzaSyBu2VuQY1so8eUTgoWyO9EVBw2miCe3_vg",
        authDomain: "angie-iot-stg.firebaseapp.com",
        projectId: "angie-iot-stg",
        storageBucket: "angie-iot-stg.appspot.com",
        messagingSenderId: "844159107862",
        appId: "1:844159107862:web:cde8daf25b1c13c9024637",
        measurementId: "G-7YV4F4T72Y"
    },
    mapTilesAddress: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    sentry: {
        enabled: true,
        environment: 'staging',
    }
};
